import { render, staticRenderFns } from "./AddEventRestrictions.vue?vue&type=template&id=49115778&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventRestrictions.vue"
export default component.exports